export default __webpack_public_path__ + "static/media/link-vip.8bba70fd.png";